//import store from "../../store";
const impressumRoutes = [
  {
    path: "/Impressum",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/Impressum.vue"
      ), 
      
  },
];

export default impressumRoutes;
